import { render, staticRenderFns } from "./PersonaldetailV2Component.vue?vue&type=template&id=5d4d5099&"
import script from "./PersonaldetailV2Component.vue?vue&type=script&lang=js&"
export * from "./PersonaldetailV2Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports